/* ==========================================================================
  main.js
========================================================================== */

"use strict";

/* global Accordion, $, Splide */

/**
 * Toggle header search
 */
const headerSearch = () => {
  const searchOpen = document.querySelector(".header-search__open");
  const searchClose = document.querySelector(".header-search__close");

  if (searchOpen) {
    searchOpen.addEventListener("click", function () {
      document
        .querySelector(".header-search")
        .classList.add("header-search--active");
    });
  }

  if (searchClose) {
    searchClose.addEventListener("click", function () {
      document
        .querySelector(".header-search")
        .classList.remove("header-search--active");
    });
  }
};

/**
 * Handle FAQ accordions
 *
 * @returns void
 */
const accordionsFaq = () => {
  const accordions = document.querySelectorAll(".faq-archive__accordions");

  if (!accordions) {
    return;
  }

  accordions.forEach((accordion) => {
    new Accordion(accordion, {
      duration: 400,
      showMultiple: false,
      elementClass: "teaser-faq",
      triggerClass: "teaser-faq__header",
      panelClass: "teaser-faq__panel",
    });
  });
};

/**
 * Handle video with image cover : play video on click
 *
 * @returns void
 */
const videoCover = () => {
  const videos = document.querySelectorAll(".video-cover--has-video");

  if (videos.length === 0) {
    return;
  }

  videos.forEach((video) => {
    const videoEl = video.querySelector("video");
    const playArea = video.querySelector(".video-cover__image");

    if (!videoEl || !playArea) {
      return;
    }

    playArea.addEventListener("click", function () {
      videoEl.play();
      document
        .querySelector(".video-cover")
        .classList.add("video-cover--active");
    });

    videoEl.addEventListener("ended", function () {
      document
        .querySelector(".video-cover")
        .classList.remove("video-cover--active");
    });
  });
};

const handleAccountNavigation = () => {
  const accountNavigation = document.querySelector(
    ".woocommerce-MyAccount-navigation"
  );

  if (accountNavigation) {
    const toggleButton = accountNavigation.querySelector(
      ".woocommerce-MyAccount-navigation__toggle"
    );
    toggleButton.addEventListener("click", function () {
      accountNavigation.classList.toggle(
        "woocommerce-MyAccount-navigation--open"
      );
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  headerSearch();
  accordionsFaq();
  videoCover();
  handleAccountNavigation();
});
